import { h } from "preact";
import { Link } from "react-router-dom";


export default function ReportsDataSource() {

    const entries = [1,2]

    function asTableView() {

        return {
            columns: [
                {
                    title: "Person Id",
                    dataIndex: "person_id",
                    render: (person_id) => (
                        <Link
                            to={`/manual_review/${person_id}`}
                            
                        >
                            {person_id}
                        </Link>
                    )
                },
                {
                    title: "Status",
                    dataIndex: "status",
                },
                {
                    title: "Services",
                    dataIndex: "services",
                },
                {
                    title: "Attempts",
                    dataIndex: "attempts",
                },
                {
                    title: "Transaction time",
                    dataIndex: "created_at",
                },
            ],
            rows: entries.map((person, index) => ({
                key: index,
                person_id: "some_id"+index,
                status: "real",
                services: "Verilive",
                attempts: '1',
                created_at: 'today',
            }))
        };
    }

    return { asTableView };
}
